'use client';

import React from 'react';
import { usePathname } from 'next/navigation';

import ThemeContext from '@/context/theme';
import { Theme } from '@/types/ui';

const PAGES_DARK_THEME = ['/', '/admissions', '/applications'];

type Props = {
  children: React.ReactNode;
};

const ThemeProvider: React.FC<Props> = ({ children }) => {
  const pathname = usePathname();

  const theme = PAGES_DARK_THEME.includes(pathname) ? Theme.DARK : Theme.LIGHT;

  return (
    <ThemeContext.Provider value={{ theme }}>{children}</ThemeContext.Provider>
  );
};

export default ThemeProvider;
